import React from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import styles from './submitButtonTooltip.module.scss';
import classnames from 'classnames';
import { MOBILE_VIEWPORT } from 'utils/constants';

type SubmitButtonTooltipProps = {
  toolTipMessage?: string;
  disabled: boolean;
  isDeepLink?: boolean;
  goNextStep?: () => void;
  isLastStep?: boolean;
  title?: string;
  isDetailsFormat?: boolean;
};

const SubmitButton = ({
  disabled = false,
  isFullScreen,
  isDeepLink,
  title,
  isDetailsFormat = false,
}: {
  disabled: boolean;
  isFullScreen: boolean;
  isDeepLink: boolean;
  title: string;
  isDetailsFormat?: boolean;
}) => {
  return (
    <Button
      data-testid="submit_button"
      variant="primary"
      type="submit"
      disabled={disabled}
      className={classnames(
        'submit-button',
        styles.submitBtn,
        {
          [styles.mobile]: !isFullScreen && !isDeepLink,
        },
        { [styles.isDetailsFormat]: isDetailsFormat }
      )}
    >
      {title}
    </Button>
  );
};

const DeepLinkButton = ({
  disabled = false,
  goNextStep,
  isLastStep,
}: {
  disabled: boolean;
  goNextStep?: () => void;
  isLastStep?: boolean;
}) => {
  return (
    <Button
      data-testid="deep_link_submit_button"
      onClick={() => {
        !isLastStep && goNextStep?.();
      }}
      type={isLastStep ? 'submit' : 'button'}
      disabled={disabled}
    >
      {isLastStep ? 'Finish' : 'Next'}
    </Button>
  );
};

const SubmitButtonTooltip = ({
  disabled,
  toolTipMessage,
  isDeepLink = false,
  goNextStep,
  isLastStep,
  title = 'Submit to client',
  isDetailsFormat = false,
}: SubmitButtonTooltipProps) => {
  const isFullScreen = window.innerWidth > MOBILE_VIEWPORT;

  return (
    <OverlayTrigger
      placement={isFullScreen ? 'top-end' : 'top'}
      trigger={toolTipMessage ? ['click', 'focus', 'hover'] : []}
      overlay={
        <Popover
          id="proposal-submit-disabled"
          className={styles.submitDisabledPopover}
        >
          <Popover.Content className={styles.submitDisabledPopoverBody}>
            {toolTipMessage}
          </Popover.Content>
        </Popover>
      }
    >
      <span
        className={classnames(
          'position-relative',
          styles.disabledSubmitBtn,
          {
            [styles.mobile]: !isFullScreen && !isDeepLink,
          },
          { [styles.showTooltip]: Boolean(toolTipMessage) },
          { [styles.isDetailsFormat]: isDetailsFormat }
        )}
      >
        {isDeepLink ? (
          <DeepLinkButton
            disabled={toolTipMessage ? true : disabled}
            goNextStep={goNextStep}
            isLastStep={isLastStep}
          />
        ) : (
          <SubmitButton
            disabled={toolTipMessage ? true : disabled}
            isDeepLink={isDeepLink}
            isFullScreen={isFullScreen}
            title={title}
            isDetailsFormat={isDetailsFormat}
          />
        )}
      </span>
    </OverlayTrigger>
  );
};

export default SubmitButtonTooltip;
